import './App.css';
import { Card, Col, Flex, Row } from 'antd';
import useSWR from 'swr';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { ClockCircleOutlined } from '@ant-design/icons';
import Loading from './Loading';

const { Title } = Typography;

interface cutType {
    id: number;
    title: string;
    bvid: string;
    time: string;
    link: string;
    cover: string;
    type: string;
}

const fetcher = async (url: string) => {
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const VideoCut = () => {
    const {
        data: recordData,
        error: recordError,
        isLoading: recordIsLoading,
    } = useSWR('https://api.lynne.com.cn/video/cut', fetcher);
    if (recordIsLoading) return <Loading />;
    if (recordError) return <div>failed to load</div>;

    // 渲染数据
    return (
        <>
            <Flex align='center' justify='middle'>
                <Title level={2} style={{ margin: '15px 0' }}>
                    切片
                </Title>
            </Flex>
            <Row gutter={[10, 10]}>
                {recordData.data.map((cut: cutType) => {
                    return (
                        <Col xs={24} sm={24} md={12} key={cut.id}>
                            <Card
                                hoverable
                                onClick={() => window.open(cut.link, 'bilibili', 'noopener=yes,noreferrer=yes')}
                                style={{ margin: '10px 0' }}>
                                <Row
                                    gutter={5}
                                    align={'middle'}
                                    justify={'center'}>
                                    <Col xs={24} sm={8} md={8}>
                                        <img
                                            src={cut.cover}
                                            className='videoImg'
                                            alt={cut.title}
                                        />
                                    </Col>
                                    <Col xs={24} sm={16} md={16}>
                                        <Title
                                            level={4}
                                            style={{ margin: '15px 0' }}>
                                            {cut.title}
                                        </Title>
                                        <Row
                                            gutter={5}
                                            align={'middle'}
                                            style={{ marginLeft: '5px' }}>
                                            <Col>
                                                <ClockCircleOutlined />
                                            </Col>
                                            <Col>
                                                {dayjs(cut.time).format(
                                                    'YYYY-MM-DD HH:mm:ss'
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        </>
    );
};

export default VideoCut;
